// Captured at import time, before router.start() — router5 (queryParamsMode
// default, wrongly assumed strict via a stale `strictQueryParams` option) must
// not be relied on to preserve ?ruid=/?error= from the DSP ruid-callback redirect.
let initialLocationSearch = window.location.search;

// Must be consumed at most once per page load — a later call to startForceShow
// (replay, or opening the modal again without a reload) must not reprocess the
// same ruid/error meant for the very first mount.
export default function takeInitialLocationSearch() {
  const value = initialLocationSearch;
  initialLocationSearch = '';
  return value;
}
